import { render, staticRenderFns } from "./Warningmessage.vue?vue&type=template&id=a4f97120&scoped=true&"
import script from "./Warningmessage.vue?vue&type=script&lang=js&"
export * from "./Warningmessage.vue?vue&type=script&lang=js&"
import style0 from "./Warningmessage.vue?vue&type=style&index=0&id=a4f97120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f97120",
  null
  
)

export default component.exports